import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

export type AlertType = 'error' | 'success' | 'warning' | 'confirm' | 'loading' | 'info';

@Component({
  selector: 'app-custom-alert',
  templateUrl: './custom-alert.component.html',
  styleUrls: ['./custom-alert.component.scss']
})
export class CustomAlertComponent implements OnInit {
  title = '';
  message = '';
  html: string | null = null;
  type: AlertType = 'success';
  showCancel = false;
  confirmText = 'Aceptar';
  cancelText = 'Cerrar';
  loading = false;

  // Accessible ids for aria attributes
  titleId: string;
  bodyId: string;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit() {
    // Get data from config
    if (this.config.data) {
      this.title = this.config.data.title || '';
      this.message = this.config.data.message || '';
      this.html = this.config.data.html || null;
      this.type = this.config.data.type || 'success';
      this.showCancel = this.config.data.showCancel || false;
      this.confirmText = this.config.data.confirmText || 'Aceptar';
      this.cancelText = this.config.data.cancelText || 'Cerrar';
      this.loading = this.config.data.loading || false;
    }

    const rnd = Math.random().toString(36).slice(2, 9);
    this.titleId = `custom-alert-title-${rnd}`;
    this.bodyId = `custom-alert-body-${rnd}`;
  }

  onConfirm() {
    this.ref.close(true);
  }

  onCancel() {
    this.ref.close(false);
  }
}
